export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-italic-4ac344d692a68df6215bc02a0298726b.svg";